import {forwardRef} from "react";
import LoginIndex from "@/views/Home/views/Login/LoginIndex";
import {useNavigate} from "react-router-dom";

const Login = forwardRef((props, ref) => {
    const navigate = useNavigate();

    return(
        <div style={{width:'100%',height:'100vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <div style={{background:'#00000002',border:'1px solid #00000011',borderRadius:'12px',padding:'36px'}}>
                <LoginIndex onCloseDialogEvent={()=>{}} onLoginSuccess={()=>{
                    navigate("/home");
                }}/>
            </div>

        </div>
    )
})

export default Login;